import React, {useState} from "react";
import {Button, FormControl, Glyphicon} from "react-bootstrap";
import {patchUnit} from "../utils/bedrockAPI";
import {apiErrorMessage, formatPortSsh, sshPort} from "../utils/unitDisplay";

export default function UnitPortField({unit, cap, onSaved, onError, bsSize}) {
    const current = unit?.port ?? cap?.port;
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState("");
    const [saving, setSaving] = useState(false);

    const startEdit = (e) => {
        if (e) e.stopPropagation();
        setValue(current != null && current !== "" ? String(current) : "");
        setEditing(true);
    };

    const cancel = (e) => {
        if (e) e.stopPropagation();
        setEditing(false);
        setValue("");
    };

    const save = async (e) => {
        if (e) e.stopPropagation();
        if (e) e.preventDefault();
        const n = parseInt(value, 10);
        if (!Number.isInteger(n) || n <= 0) {
            if (typeof onError === "function") {
                onError("Port must be a positive integer (nginx tunnel, typically 8xxx).");
            }
            return;
        }
        if (Number(current) === n) {
            setEditing(false);
            return;
        }
        const ssh = n - 5780;
        if (
            !window.confirm(
                `Set port ${n} (SSH ${ssh}) on this unit and its current cap?\n\n` +
                    `Tunnels follow this after the box polls assignment or nginx/autossh are updated.`
            )
        ) {
            return;
        }
        setSaving(true);
        try {
            const updated = await patchUnit(unit.unitId, {port: n});
            if (typeof onSaved === "function") {
                await onSaved(updated, n);
            }
            setEditing(false);
        } catch (err) {
            if (typeof onError === "function") {
                onError(apiErrorMessage(err));
            }
        }
        setSaving(false);
    };

    const parsed = parseInt(value, 10);
    const sshPreview = Number.isInteger(parsed) && parsed > 0 ? sshPort(parsed) : null;

    if (!editing) {
        return (
            <div className="units-port-field">
                <span className="units-meta-value">{formatPortSsh(current)}</span>
                <Button
                    bsSize="xsmall"
                    bsStyle="default"
                    title="Edit port on this unit and its current cap"
                    onClick={startEdit}
                    style={{marginLeft: 8}}
                >
                    <Glyphicon glyph="pencil" />
                </Button>
            </div>
        );
    }

    return (
        <form className="units-port-edit" onSubmit={save}>
            <FormControl
                type="number"
                min="1"
                step="1"
                bsSize={bsSize || undefined}
                autoFocus
                value={value}
                disabled={saving}
                onChange={(e) => setValue(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                placeholder="e.g. 8123"
                title="Nginx tunnel port; SSH is this minus 5780"
            />
            {sshPreview != null && (
                <div className="units-id-muted">SSH {sshPreview}</div>
            )}
            <div className="units-port-edit-actions">
                <Button type="submit" bsSize="xsmall" bsStyle="primary" disabled={saving}>
                    {saving ? "Saving…" : "Save"}
                </Button>
                <Button bsSize="xsmall" bsStyle="default" disabled={saving} onClick={cancel}>
                    Cancel
                </Button>
            </div>
        </form>
    );
}
